export interface SharedPlace {
  lat: number;
  lon: number;
  label: string;
}

const validLat = (n: number) => Number.isFinite(n) && Math.abs(n) <= 90;
const validLon = (n: number) => Number.isFinite(n) && Math.abs(n) <= 180;

export function isValidPlace(p: unknown): p is SharedPlace {
  const v = p as SharedPlace;
  return !!v && typeof v.label === "string" && validLat(v.lat) && validLon(v.lon);
}

const NUMBER = /^-?\d+(\.\d+)?$/;

// Place from ?lat=..&lon=..&place=.. in the current URL, if present and valid.
export function readSharedPlace(): SharedPlace | null {
  const q = new URLSearchParams(window.location.search);
  const rawLat = q.get("lat")?.trim() ?? "";
  const rawLon = q.get("lon")?.trim() ?? "";
  if (!NUMBER.test(rawLat) || !NUMBER.test(rawLon)) return null;
  const lat = Number(rawLat);
  const lon = Number(rawLon);
  const label = (q.get("place") ?? "").slice(0, 200) || `${lat.toFixed(4)}°, ${lon.toFixed(4)}°`;
  const place = { lat, lon, label };
  return isValidPlace(place) ? place : null;
}

export function buildShareUrl({ lat, lon, label }: SharedPlace): string {
  const url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.set("lat", lat.toFixed(4));
  url.searchParams.set("lon", lon.toFixed(4));
  url.searchParams.set("place", label);
  return url.toString();
}

// Drop share parameters from the address bar once the visitor picks their own place.
export function clearShareParams() {
  if (window.location.search) window.history.replaceState(null, "", window.location.pathname);
}
